import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Check, Zap } from "lucide-react";
import PageHeader from "../components/PageHeader";
import { Reveal } from "../components/Reveal";
import { api, useContent } from "../lib/api";

export default function Programs() {
  const { data: plans } = useContent("plans");
  const [paid, setPaid] = useState([]);
  useEffect(() => { api.get("/programs").then((r) => setPaid(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="programs-page">
      <PageHeader overline="Coaching Programs" title={<>Programs<br />built to fit you</>}
        subtitle="Structured, progressive coaching for every goal and level. Pricing in INR. Support included with every plan." />
      <section className="mx-auto max-w-[1400px] px-5 lg:px-8 py-16 md:py-24 space-y-6">
        {plans.map((p, i) => (
          <Reveal key={p.id} delay={i * 0.05}>
            <div data-testid="plan-item" className="grid md:grid-cols-12 gap-6 border border-border rounded-lg overflow-hidden bg-card">
              <div className="md:col-span-4 aspect-[4/3] md:aspect-auto overflow-hidden">
                <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
              </div>
              <div className="md:col-span-8 p-7 md:p-9">
                <div className="flex flex-wrap items-center gap-2 text-xs uppercase tracking-[0.12em] font-bold mb-3">
                  <span className="text-primary">{p.level}</span><span className="text-muted-foreground">/ {p.duration} / {p.goal}</span>
                </div>
                <div className="flex flex-wrap items-baseline justify-between gap-3">
                  <h2 className="font-display font-800 uppercase text-4xl md:text-5xl tracking-tight">{p.title}</h2>
                  <span className="font-display font-800 text-4xl text-primary">{p.price}</span>
                </div>
                <p className="text-muted-foreground mt-3 max-w-2xl">{p.description}</p>
                <ul className="grid sm:grid-cols-2 gap-2.5 mt-5">
                  {(p.features || []).map((f) => (
                    <li key={f} className="flex items-center gap-2.5 text-sm"><Check size={16} className="text-primary shrink-0" /> {f}</li>
                  ))}
                </ul>
                <Link to="/booking" data-testid="plan-enroll"
                  className="inline-block mt-7 bg-primary text-primary-foreground px-8 py-4 rounded-full text-xs uppercase tracking-[0.15em] font-bold hover:scale-[1.03] transition-transform">
                  Enroll / Enquire
                </Link>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      {paid.length > 0 && (
        <section className="mx-auto max-w-[1400px] px-5 lg:px-8 pb-16 md:pb-24" data-testid="paid-programs-section">
          <div className="flex flex-wrap items-baseline gap-4 mb-8">
            <h2 className="font-display font-900 uppercase text-4xl md:text-5xl tracking-tight">Digital Challenges</h2>
            <span className="inline-flex items-center gap-1.5 text-xs uppercase tracking-[0.15em] text-primary font-bold"><Zap size={13} /> Instant access · online</span>
          </div>
          <div className="grid gap-6 md:grid-cols-2">
            {paid.map((p, i) => (
              <Reveal key={p.id} delay={i * 0.05}>
                <div data-testid="paid-program-card" className="border border-border rounded-lg bg-card overflow-hidden h-full flex flex-col">
                  {p.thumbnail && <img src={p.thumbnail} alt={p.title} className="w-full aspect-video object-cover" loading="lazy" />}
                  <div className="p-7 md:p-9 flex flex-col flex-1">
                  <div className="flex flex-wrap items-center gap-2 text-xs uppercase tracking-[0.12em] font-bold mb-3">
                    <span className="text-primary">{p.duration_days} days</span>
                    <span className="text-muted-foreground">/ {(p.levels || []).join(" · ")} / {(p.languages || []).join(" · ")}</span>
                  </div>
                  <div className="flex flex-wrap items-baseline justify-between gap-3">
                    <h3 className="font-display font-800 uppercase text-3xl md:text-4xl tracking-tight">{p.title}</h3>
                    <span className="font-display font-800 text-4xl text-primary">₹{((p.price_paise || 0) / 100).toLocaleString("en-IN")}</span>
                  </div>
                  <p className="text-muted-foreground mt-3 flex-1">{p.tagline || p.description}</p>
                  <Link to={`/programs/${p.slug || p.id}`} data-testid="paid-program-enrol"
                    className="inline-block self-start mt-6 bg-primary text-primary-foreground px-8 py-4 rounded-full text-xs uppercase tracking-[0.15em] font-bold hover:scale-[1.03] transition-transform">
                    Enrol Now
                  </Link>
                  </div>
                </div>
              </Reveal>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}
